module.exports = __webpack_public_path__ + "img/index-section7-award7.a77809a6.png";